// @flow

import * as React from 'react';

import type { ProductId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Base, Switch, PopoverIcon } from '@gandi/ui';

export type Props = {
  checked: boolean,
  onChange: (evt: SyntheticInputEvent<>) => mixed,
  /** productId is used to generate a unique field id */
  productId: ProductId,
};

export function AutoRenewRow({
  checked,
  onChange,
  productId,
}: Props): React.MixedElement | null {
  const { __ } = useTranslator();

  const name = 'autorenewStatus';

  /** Legacy style */
  return (
    <Base flex flexAlignItemsCenter gap="xxsmall">
      <Switch
        name={name}
        checked={checked}
        onChange={onChange}
        flexAlignItemsCenter
      >
        {__('Automatic renewal')}
      </Switch>
      <PopoverIcon
        icon="infoWire"
        id={`icon-${name}-${productId}`}
        title={__('Automatic renewal information')}
      >
        {__(
          'When reaching the expiration date, we will automatically renew products for you. ' +
            "This is handy for products you don't want to lose. " +
            'The renewal will be done on the saved credit card or on the related prepaid account.',
        )}
      </PopoverIcon>
    </Base>
  );
}
